export const DEFALUT = 'default'
export const MASTERMULTICINEMA = 'multiClient'
export const MASTERMULTINAVIGATION = 'multiNavigation'
export const MASTERMULTITOTAL = 'multiTotal'

export const MULTICINEMA = 'multi'
export const SINGLECINEMA = 'single'
